// tabs — default skin module
// Token disposition: pass-through (no overrides)
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: flex;
    flex-direction: column;
  }
  :host([orientation="vertical"]) {
    flex-direction: row;
  }
  [part="base"] {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  :host([orientation="vertical"]) [part="base"] {
    flex-direction: row;
  }
  [part="tablist-container"] {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid var(--run-tabs-tablist-border, var(--run-color-border-default));
    gap: var(--run-tabs-gap, 0);
  }
  :host([orientation="vertical"]) [part="tablist-container"] {
    flex-direction: column;
    border-bottom: none;
    border-inline-end: 1px solid var(--run-tabs-tablist-border, var(--run-color-border-default));
  }
  [part="panel-region"] {
    flex: 1;
  }
  [part="fade-start"],
  [part="fade-end"] {
    display: none;
    pointer-events: none;
    position: absolute;
  }
  :host([scrollable]) [part="tablist-container"] {
    overflow-x: auto;
    scrollbar-width: none;
    position: relative;
  }
  :host([scrollable][orientation="vertical"]) [part="tablist-container"] {
    overflow-x: unset;
    overflow-y: auto;
  }
  :host([scrollable]) [part="fade-start"],
  :host([scrollable]) [part="fade-end"] {
    display: block;
  }
`;

export function render(host) {
  const { orientation, scrollable } = host;
  const fadeAffordances = scrollable
    ? `<div part="fade-start" aria-hidden="true"></div>
       <div part="fade-end" aria-hidden="true"></div>`
    : '';
  // Tabs and panels are projected into their respective regions via named
  // slots. run-tabs assigns slot="tablist" to <run-tab> children and
  // slot="panel" to <run-tab-panel> children (see #syncChildren), so the
  // tablist renders as a horizontal (or vertical) bar and panels render in
  // the panel region — without the consumer needing to set slot attributes.
  host.shadowRoot.innerHTML = `
    <div part="base" class="run-tabs__base">
      <run-box part="tablist-container" role="tablist" aria-orientation="${orientation === 'vertical' ? 'vertical' : 'horizontal'}">
        <slot name="tablist"></slot>
      </run-box>
      <div part="panel-region">
        <slot name="panel"></slot>
      </div>
      ${fadeAffordances}
    </div>
  `;
}